import { type ButtonHTMLAttributes, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  loading?: boolean;
  fullWidth?: boolean;
}

const styles = {
  primary:
    'bg-primary text-white hover:bg-primary-light disabled:bg-primary/50',
  secondary:
    'bg-secondary text-white hover:bg-secondary-light disabled:bg-secondary/50',
  ghost:
    'bg-transparent text-primary hover:bg-primary/5 border border-primary',
};

export const Button = forwardRef<HTMLButtonElement, Props>(function Button(
  { variant = 'primary', loading, fullWidth, className, children, disabled, ...rest },
  ref
) {
  return (
    <button
      ref={ref}
      disabled={disabled || loading}
      className={twMerge(
        'inline-flex items-center justify-center rounded-xl px-5 py-3 font-semibold transition disabled:cursor-not-allowed',
        styles[variant],
        fullWidth && 'w-full',
        className
      )}
      {...rest}
    >
      {loading ? <span className="animate-pulse">…</span> : children}
    </button>
  );
});
